import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import DeviceDetailsSimsTable from './components/DeviceDetailsSimsTable';
import DeviceDetailsInfoRows from '../../ESimManager/UserDetails/DeviceDetails/DeviceDetailsInfoRows';
import useDeviceDetails from './useDeviceDetails';
import AssignSimDrawer from '../../ESimManager/UserDetails/components/AssignSimDrawer/AssignSimDrawer';

function UnassignedDeviceDetails() {
  const { id } = useParams();
  const [t] = useTranslation();
  const { device, sims, fetchDeviceDetails, updateDeviceDetails, isLoading, updateSimDetails, deleteDeviceHandler } =
    useDeviceDetails(id);
  const [showAssignSim, setShowAssignSim] = useState(false);

  /**
   * Init assign sim
   */
  const assignSim = () => {
    setShowAssignSim(true);
  };

  return (
    <Box>
      <Breadcrumbs
        activeLinks={[
          { label: t('navbar.dashboard'), url: '/dashboard' },
          { label: t('pages.devicesReport.unassignedTitle'), url: '/dashboard/unassignedReport' },
        ]}
        disabledLinks={[device ? `${device?.manufacturer} ${device?.model}` : '']}
      />
      <DeviceDetailsInfoRows
        device={device}
        sims={sims}
        isLoading={isLoading}
        updateDeviceDetails={updateDeviceDetails}
        deleteDevice={deleteDeviceHandler}
        editMode
        assignSim={assignSim}
      />
      <DeviceDetailsSimsTable
        device={device}
        sims={sims}
        isLoading={isLoading}
        showTotalSims={false}
        isPerformingAction={isLoading}
        updateSim={updateSimDetails}
        assignSim={assignSim}
      />
      {showAssignSim ? (
        <AssignSimDrawer
          onClose={() => {
            setShowAssignSim(false);
          }}
          open={showAssignSim}
          onAssignSimSuccess={fetchDeviceDetails}
          device={device}
        />
      ) : null}
    </Box>
  );
}

export default UnassignedDeviceDetails;
